import React, { useEffect, useState } from "react";
import { Accordion } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { MinusIconCircle, PlusIconCircle } from "../../asset/icons/Icon";
import { images, notifySuccess } from "../../actions/customFn";
import { FiEdit } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import axios from "../../api/axios";
import moment from "moment";
import Loader from "../../utils/Loader";
import { asyncSendNotification } from "../../actions/notificationApi";


const QnaAccordian = ({
  qnaList,
  batchName,
  selectedBatch,
  setSelectedBatch,
  allBatches,
  isLoading,
}) => {
  const [qnaArr, setQnaArr] = useState([]);
  const [moduleIds, setModuleIds] = useState([]);

  useEffect(() => {
    if (qnaList && qnaList.length > 0) {
      const qna = [];
      const moduleId = [];
      for (let i = 0; i < qnaList.length; i++) {
        if (qnaList[i].qna.length > 0) {
          qna.push(qnaList[i].qna);
          for (let y = 0; y < qnaList[i].qna.length; y++) {
            moduleId.push(qnaList[i]._id);
          }
        }
      }
      setQnaArr([].concat(...qna));
      setModuleIds(moduleId);
    }
  }, [qnaList]);

return (
  <div
    className="qna_accordian_container"
    style={{
      backgroundColor: "#292929",
      color: "#ffffff",
      padding: "10px",
      borderRadius: "8px",
    }}
  >
    <div
      className="qna_accordian_options"
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "10px",
      }}
    >
      <div
        className="qna_accordian_links"
        style={{ display: "flex", gap: "10px" }}
      >
        <NavLink
          to={"/qna"}
          style={{ color: "#ffffff", textDecoration: "none" }}
        >
          All
        </NavLink>

        <NavLink
          to={"/qna-answered"}
          style={{ color: "#ffffff", textDecoration: "none" }}
        >
          Answered
        </NavLink>

        <NavLink
          to={"/qna-unanswered"}
          style={{ color: "#ffffff", textDecoration: "none" }}
        >
          Unanswered
        </NavLink>
      </div>

      <div className="qna_accordian_select">
        <select
          value={selectedBatch}
          onChange={(e) => setSelectedBatch(e.target.value)}
          style={{
            backgroundColor: "#292929",
            color: "#ffffff",
            border: "1px solid #444",
            borderRadius: "6px",
            padding: "6px",
          }}
        >
          <option value={""}>Select Batch</option>
          {allBatches?.length > 0 &&
            allBatches.map((data, i) => {
              return (
                <option
                  key={i}
                  value={data.batch_name}
                  style={{
                    backgroundColor: "#292929",
                    color: "#ffffff",
                  }}
                >
                  {data.batch_name}
                </option>
              );
            })}
        </select>
      </div>
    </div>

    {isLoading ? (
      <Loader Height={"65vh"} />
    ) : (
      <div
        className="qna_accordian_scroll scrollbar-template"
        style={{
          backgroundColor: "#292929",
          color: "#ffffff",
        }}
      >
        <Accordion
          defaultActiveKey=""
          className="qna_accordian_div"
          style={{
            backgroundColor: "#292929",
            color: "#ffffff",
          }}
        >
          {qnaArr.map((data, index) => {
            return (
              <QnaItems
                data={data}
                batchName={batchName}
                index={index}
                moduleID={moduleIds[index]}
              />
            );
          })}
        </Accordion>

        {isLoading === false && qnaArr.length === 0 && (
          <h4
            style={{
              color: "#ffffff",
              textAlign: "center",
              marginTop: "20px",
            }}
          >
            No QnA Found!
          </h4>
        )}
      </div>
    )}
  </div>
);
};

export default QnaAccordian;

const QnaItems = ({ data, index, batchName, moduleID, num }) => {
  const [isOpen, setIsopen] = useState(false);
  const [isInput, setIsInput] = useState(false);

  const dispatch = useDispatch();

  const handleAccordionToggle = () => {
    setIsopen(!isOpen);
  };

  const profileData = useSelector((state) => state.profileData.userData);
  const [ansInp, setAnsInp] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [ansId, setansId] = useState("");

  const [batchInfo, setBatchInfo] = useState("");

  useEffect(() => {
    if (data && profileData && Object.keys(profileData).length > 0) {
      const filerArr = data.answers.find(
        (data) => data.user._id === profileData._id
      );
      if (filerArr) {
        setAnsInp(filerArr.ans);
        setansId(filerArr._id);
        setIsEdit(true);
      } else {
        setIsEdit(false);
        setAnsInp("");
        setansId("");
      }
    }
  }, [profileData, data]);

  const postQnaAnswer = () => {
    const url = `/batch/qna-ask-answer`;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };

    const formData = {
      user: profileData._id,
      answer: ansInp,
      questionId: data._id,
    };

    axios
      .put(url, formData, config)
      .then((res) => {
        const { message } = res.data;
        // setIsUpdate((p) => !p);
        const notifyData = {
          recipientArr: [data?.question?.user?._id],
          messages: {
            notification_msg: `Instructor Responded to Your Query.`,
            date: new Date(),
            notification_type: "qna",
          },
        };
        dispatch(asyncSendNotification(notifyData));
        notifySuccess(message);
      })
      .catch((err) => {
        // setIsLoading(false);
        console.log(err.response);
      });
  };

  const updateQnaAnswer = () => {
    const url = `/batch/qna-answer-edit`;
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("skillanthem_auth")}`,
      },
    };

    const formData = {
      answerId: ansId,
      answer: ansInp,
      questionId: data._id,
    };

    axios
      .put(url, formData, config)
      .then((res) => {
        const { message } = res.data;
        // setIsUpdate((p) => !p);
        notifySuccess(message);
        const notifyData = {
          recipientArr: [data?.question?.user?._id],
          messages: {
            notification_msg: `Instructor Responded to Your Query`,
            date: new Date(),
            notification_type: "qna",
          },
        };
        dispatch(asyncSendNotification(notifyData));
      })
      .catch((err) => {
        // setIsLoading(false);
        console.log(err.response);
      });
  };

  const handleClick = () => {
    if (isEdit) {
      updateQnaAnswer();
    } else {
      postQnaAnswer();
    }
  };

  useEffect(() => {
    if (batchName && batchName.length > 0) {
      const currentBatchName = batchName.find((arr) =>
        arr.modules.includes(moduleID)
      );
      setBatchInfo(currentBatchName);
    }
  }, [batchName]);

return (
  <Accordion.Item
    eventKey={index}
    className={isOpen ? "qna_items qna_items_active" : "qna_items"}
    key={index}
    onClick={handleAccordionToggle}
    style={{
      backgroundColor: "#292929",
      color: "#ffffff",
      borderRadius: "8px",
      border: "none",
    }}
  >
    <Accordion.Header
      style={{
        backgroundColor: "#292929",
        color: "#ffffff",
      }}
    >
      <div
        className="program_preview_accordin_header qna_header"
        style={{ color: "#ffffff" }}
      >
        <div className="qna_header_heading">
          <h3 style={{ color: "#ffffff" }}>
            {index + 1}. {data.question.query}
          </h3>
        </div>

        <div className="qna_header_date" style={{ color: "#ffffff" }}>
          {isOpen ? (
            <MinusIconCircle style={{ color: "#ffffff" }} />
          ) : (
            <PlusIconCircle style={{ color: "#ffffff" }} />
          )}
        </div>
      </div>

      <div
        className="program_preview_info"
        style={{ color: "#ffffff" }}
      >
        <span
          className="program_preview_info_name"
          style={{ color: "#ffffff" }}
        >
          {batchInfo.batch_name}
        </span>

        <span
          className="program_preview_info_date"
          style={{ color: "#ffffff" }}
        >
          {isEdit && <b style={{ color: "#ffffff" }}>answered:</b>}
          {moment(data.question.date).format("DD MMM YYYY LT")}
        </span>
      </div>
    </Accordion.Header>

    <Accordion.Body
      style={{
        backgroundColor: "#292929",
        color: "#ffffff",
      }}
    >
      <div
        className="program_preview_accordin_body qna_body"
        onClick={(e) => e.stopPropagation()}
        style={{ color: "#ffffff" }}
      >
        <div
          className="qna_body_user"
          style={{ color: "#ffffff" }}
        >
          <img
            key={data?.question?.user?.image}
            src={data?.question?.user?.image}
            alt=""
            style={{ borderRadius: "50%" }}
          />
          <span style={{ color: "#ffffff" }}>
            {data?.question?.user?.username}
          </span>
        </div>

        {isEdit && !isInput && (
          <div
            className="qna_body_desc"
            style={{ color: "#ffffff" }}
          >
            <p key={index} style={{ color: "#ffffff" }}>
              {ansInp}
            </p>

            <div className="d-flex justify-content-end">
              <FiEdit
                onClick={(e) => {
                  e.stopPropagation();
                  setIsInput(true);
                }}
                style={{ color: "#ffffff", cursor: "pointer" }}
              />
            </div>
          </div>
        )}

        {(!isEdit || isInput) && (
          <div
            className="qna_body_inp"
            style={{ color: "#ffffff" }}
          >
            <textarea
              rows={"3"}
              placeholder="Enter Your answer"
              value={ansInp}
              onChange={(e) => setAnsInp(e.target.value)}
              style={{
                backgroundColor: "#292929",
                color: "#ffffff",
                border: "1px solid #444",
                borderRadius: "6px",
                padding: "8px",
              }}
            />

            <button
              onClick={(e) => {
                e.stopPropagation();
                handleClick();
              }}
              style={{
                backgroundColor: "#10b981",
                color: "#ffffff",
                border: "none",
                padding: "6px 12px",
                borderRadius: "6px",
                marginTop: "8px",
              }}
            >
              {isEdit ? "Update" : "Send"}
            </button>
          </div>
        )}
      </div>
    </Accordion.Body>
  </Accordion.Item>
);
};
